/* ==========================================================================
   Cart Upsell — cross-sell recommendations, discount field, sticky ATC.
   Progress bar & savings are Liquid-rendered; this file only handles the
   pieces that need JS and must survive Dawn's drawer re-renders.
   ========================================================================== */
(function () {
  'use strict';

  var COUNTDOWN_KEY = 'cu_countdown_end';
  var csCache = {}; // product_id -> rendered html (avoids refetch on every re-render)

  /* ---------- countdown timer (session-persistent, survives re-renders) ---------- */
  function tickCountdown() {
    var clock = document.querySelector('[data-cu-countdown-clock]');
    if (!clock) return;
    var host = document.querySelector('[data-cu-countdown]');
    var minutes = host ? (parseInt(host.getAttribute('data-minutes'), 10) || 10) : 10;
    var end = parseInt(sessionStorage.getItem(COUNTDOWN_KEY), 10);
    var now = Date.now();
    if (!end || isNaN(end) || end <= now) {
      end = now + minutes * 60000;
      sessionStorage.setItem(COUNTDOWN_KEY, end);
    }
    var rem = Math.max(0, Math.floor((end - now) / 1000));
    var m = Math.floor(rem / 60);
    var s = rem % 60;
    clock.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  /* ---------- money formatting (classic Shopify money_format) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '${{amount}}';

    function defaultTo(num, size) {
      num = (num || 0).toString();
      while (num.length < size) num = '0' + num;
      return num;
    }
    function thousands(num, precision, thousandsSep, decimalSep) {
      thousandsSep = thousandsSep || ',';
      decimalSep = decimalSep || '.';
      if (isNaN(num) || num == null) return 0;
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousandsSep);
      var centsPart = parts[1] ? decimalSep + parts[1] : '';
      return dollars + centsPart;
    }

    var val, match = fmt.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': val = thousands(cents, 2); break;
      case 'amount_no_decimals': val = thousands(cents, 0); break;
      case 'amount_with_comma_separator': val = thousands(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = thousands(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': val = thousands(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': val = thousands(cents, 0, ' ', ''); break;
      default: val = thousands(cents, 2);
    }
    return fmt.replace(placeholderRegex, val);
  }

  /* ---------- cross-sell ----------
     The grid is pre-filled server-side from the fallback collection, so it is
     never empty. Recommendations are layered on top when available; items
     already in the cart are excluded so it keeps offering fresh products. */
  function renderCrossSell() {
    var host = document.querySelector('[data-cu-crosssell]');
    if (!host) return;
    var grid = host.querySelector('[data-cu-cs-grid]');
    if (!grid) return;

    // Never leave a lone heading: hide only if there's genuinely nothing to show.
    host.style.display = grid.children.length ? '' : 'none';

    var pid = host.getAttribute('data-product-id');
    var limit = parseInt(host.getAttribute('data-limit'), 10) || 6;
    var moneyFormat = host.getAttribute('data-money-format') || '${{amount}}';
    var cartPids = (host.getAttribute('data-cart-pids') || '')
      .split(',').filter(function (x) { return x; });
    if (!pid) return;

    var cacheKey = pid + '|' + cartPids.join(',');
    if (csCache[cacheKey]) { grid.innerHTML = csCache[cacheKey]; host.style.display = ''; return; }

    var url = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/');
    url += 'recommendations/products.json?product_id=' + encodeURIComponent(pid) +
           '&limit=' + (limit + cartPids.length) + '&intent=related';

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.products || []).filter(function (p) {
          return cartPids.indexOf(String(p.id)) === -1;
        });
        // No usable recommendations → keep the server-rendered fallback grid.
        if (!products.length) return;

        var html = products.slice(0, limit).map(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var vid = p.variants && p.variants[0] ? p.variants[0].id : '';
          var available = p.available !== false && vid;
          // Compare-at price → sale tag + struck-through original
          var cmp = (p.compare_at_price != null ? p.compare_at_price : p.compare_at_price_min) || 0;
          var onSale = cmp > p.price;
          var priceHtml = onSale
            ? '<span class="cu-cs-price-sale">' + formatMoney(p.price, moneyFormat) + '</span> ' +
              '<s class="cu-cs-price-was">' + formatMoney(cmp, moneyFormat) + '</s>'
            : formatMoney(p.price, moneyFormat);
          return (
            '<div class="cu-cs-card">' +
              (onSale ? '<span class="cu-cs-badge">Sale</span>' : '') +
              '<a href="' + p.url + '" tabindex="-1">' +
                (img ? '<img src="' + img + '" alt="' + (p.title || '') + '" loading="lazy" width="150" height="150">' : '<img alt="" width="150" height="150">') +
              '</a>' +
              '<div class="cu-cs-title">' + (p.title || '') + '</div>' +
              '<div class="cu-cs-price">' + priceHtml + '</div>' +
              '<button type="button" class="cu-cs-add" data-cu-cs-add data-variant-id="' + vid + '"' +
                (available ? '' : ' disabled') + '>' +
                (available ? 'Add' : 'Sold out') +
              '</button>' +
            '</div>'
          );
        }).join('');
        csCache[cacheKey] = html;
        grid.innerHTML = html;
        host.style.display = '';
      })
      .catch(function () { /* keep server-rendered fallback */ });
  }

  /* ---------- add cross-sell item to cart, then refresh the drawer ---------- */
  function addToCart(variantId, btn) {
    if (!variantId) return;
    var original = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    var cartDrawer = document.querySelector('cart-drawer');
    var body = {
      items: [{ id: variantId, quantity: 1 }],
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    };

    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(res);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData: res });
        }
      })
      .catch(function () {
        btn.textContent = original;
        btn.disabled = false;
      });
  }

  /* ---------- discount field ---------- */
  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  // POST the discount to the cart. When wantSections is true, ask cart/update.js
  // to return the rendered cart-drawer HTML in the SAME response (one round-trip).
  function setCartDiscount(code, wantSections) {
    var body = { discount: code };
    if (wantSections) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // Render the drawer from a `sections` object returned by cart/update.js.
  function renderFromSections(sections) {
    if (!sections) return;
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents({ sections: sections, id: null });
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell-discount' });
    }
  }

  // Auto-added gift lines (free balls / clickers) from the Pair Bundle offer.
  function giftLines(cart) {
    return (cart.items || []).filter(function (item) {
      var props = item.properties || {};
      return props._auto_gift === '1' || props._pair_role === 'gift';
    });
  }

  function codeApplied(cart, code) {
    var match = (cart.discount_codes || []).filter(function (d) {
      return d.code && d.code.toLowerCase() === code.toLowerCase();
    })[0];
    return match ? match.applicable
      : !!(cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0);
  }

  function hasBundleDiscount(cart) {
    return (cart.items || []).some(function (item) {
      return (item.line_level_discount_allocations || []).some(function (a) {
        var app = a.discount_application || {};
        return app.type !== 'discount_code' && /pair bundle/i.test(app.title || '');
      });
    });
  }

  // Same update that removes the gift lines also carries the code, so Shopify
  // compares the code against the bundle without the free items inflating it.
  function retryWithoutGifts(code, gifts) {
    var updates = {};
    gifts.forEach(function (item) { updates[item.key] = 0; });
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        discount: code,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    }).then(function (r) { return r.json(); });
  }

  function restoreGifts(gifts) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: gifts.map(function (item) {
          return { id: item.variant_id || item.id, quantity: item.quantity, properties: item.properties };
        })
      })
    }).then(function (r) { return r.json(); });
  }

  function applyDiscount() {
    var wrap = document.querySelector('[data-cu-discount]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-cu-discount-input]');
    var note = wrap.querySelector('[data-cu-discount-note]');
    var btn = wrap.querySelector('[data-cu-discount-apply]');
    var code = (input && input.value ? input.value : '').trim();
    if (!code) return;

    if (btn) { btn.dataset.label = btn.textContent; btn.textContent = '…'; btn.disabled = true; }
    wrap.classList.remove('cu-error');

    function fail(cart) {
      var message = cart && hasBundleDiscount(cart)
        ? 'Code “' + code + '” can’t be combined with the Pair Bundle offer'
        : 'Code “' + code + '” isn’t valid for this cart';
      if (note) note.textContent = message;
      wrap.classList.add('cu-error');
    }

    // Single request: applies the code AND returns the re-rendered sections.
    setCartDiscount(code, true)
      .then(function (cart) {
        if (codeApplied(cart, code)) {
          if (note) note.textContent = '';
          renderFromSections(cart.sections);
          return;
        }

        // The free gifts can push the bundle's saving above the code's, so a code
        // that loses may still win once they are out. Try that once.
        var gifts = giftLines(cart);
        if (!gifts.length) {
          // Not applicable — clear the bad code (no re-render, keep the error note visible).
          fail(cart);
          return setCartDiscount('', false);
        }
        return retryWithoutGifts(code, gifts).then(function (retried) {
          if (codeApplied(retried, code)) {
            if (note) note.textContent = '';
            renderFromSections(retried.sections);
            return;
          }
          fail(retried);
          return restoreGifts(gifts).then(function () { return setCartDiscount('', false); });
        });
      })
      .catch(function () {
        if (note) note.textContent = 'Could not apply code. Please try again.';
        wrap.classList.add('cu-error');
      })
      .then(function () {
        if (btn) { btn.textContent = btn.dataset.label || 'Apply'; btn.disabled = false; }
      });
  }

  function removeDiscount() {
    setCartDiscount('', true).then(function (cart) { renderFromSections(cart.sections); });
  }

  /* ---------- sticky ATC ---------- */
  function initSticky() {
    var bar = document.getElementById('cu-sticky-atc');
    if (!bar) return;
    var lastShow = null;
    var ticking = false;
    // Templates can hold the bar back until a given element (e.g. the add to cart
    // button) has scrolled past; without the attribute it shows after 300px.
    var afterId = bar.getAttribute('data-cu-show-after');
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var after = afterId && document.getElementById(afterId);
        var show = after ? after.getBoundingClientRect().bottom < 0 : window.scrollY > 300;
        if (show !== lastShow) {
          lastShow = show;
          bar.classList.toggle('cu-show', show);
          document.body.classList.toggle('cu-sticky-visible', show);
        }
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- delegated events (survive re-renders) ---------- */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-cu-cs-add]');
    if (addBtn) { addToCart(addBtn.getAttribute('data-variant-id'), addBtn); return; }

    var toggle = e.target.closest('[data-cu-discount-toggle]');
    if (toggle) {
      var w = toggle.closest('[data-cu-discount]');
      var open = w.classList.toggle('cu-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var applyBtn = e.target.closest('[data-cu-discount-apply]');
    if (applyBtn) { applyDiscount(); return; }

    var removeBtn = e.target.closest('[data-cu-discount-remove]');
    if (removeBtn) { removeDiscount(); return; }

    var stickyAdd = e.target.closest('[data-cu-sticky-add]');
    if (stickyAdd) {
      if (stickyAdd.getAttribute('aria-disabled') === 'true') return;
      var formId = stickyAdd.getAttribute('data-form');
      var form = formId ? document.getElementById(formId) : document.querySelector('product-form form');
      var realBtn = form ? form.querySelector('[type="submit"][name="add"], button[name="add"], .product-form__submit') : null;
      if (realBtn) realBtn.click();
      return;
    }
  });

  // Start the 1s countdown interval only when a clock is present, and only once.
  var countdownTimer = null;
  function ensureCountdown() {
    if (countdownTimer || document.hidden) return;
    if (!document.querySelector('[data-cu-countdown-clock]')) return;
    countdownTimer = setInterval(tickCountdown, 1000);
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      clearInterval(countdownTimer);
      countdownTimer = null;
    } else {
      tickCountdown();
      ensureCountdown();
    }
  });

  function refresh() {
    renderCrossSell();
    tickCountdown();   // immediate update of the (possibly re-rendered) clock
    ensureCountdown(); // lazily start the ticking interval if a clock exists
  }

  document.addEventListener('DOMContentLoaded', function () {
    refresh();
    initSticky();
  });

  // Re-run after Dawn re-renders the drawer.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 0); });
  }
})();
